<div
  class="container-fluid p-5 pt-3"
  style="min-height: calc(100vh - 57px) !important"
>
  <div class="ms-5" style="min-height: calc(100vh - 121px) !important">
    <div class="row" style="min-height: calc(100vh - 121px) !important">
      <!-- BREADCRUMB -->
      <!-- <div class="col-12 mb-3 d-flex align-items-center"> -->
      <div class="col-12 mb-3 d-flex align-items-start">
        <a href="/home" class="text-decoration-none">
          <p class="cc-breadcrumb-home">HOME</p>
        </a>
      </div>

      <!-- TITULO COMPONENTE -->

      <div class="container-home">
        <img class="img1" src="assets/img/img1_home.svg" alt="img1 home" />
        <img
          src="assets/img/logo-sofofa-color.svg"
          width="200px"
          alt="Logo Sofofa"
        />
        <div class="container-img-line">
          <img src="assets/img/line_home.svg" alt="line home" />
          <p>
            Bienvenido a <br />
            Centralización de Remuneraciones
          </p>
        </div>
      </div>
    </div>
  </div>
</div>